export const financialReportsApiHandler = {
  getSalesRevenue: {
    method: "GET",
    path: () => `org-orders-management/reports/sales-revenue`,
    params: {} as {
      'startDate'?: string | number,
      'endDate'?: string | number,
      'groupBy'?: string,
    }
  },
  getProgramRevenue: {
    method: "GET",
    path: () => `org-orders-management/reports/program-revenue`,
    params: {} as {
      'skip'?: string | number,
      'take'?: string | number,
      'startDate'?: string | number,
      'endDate'?: string | number,
      'itemId'?: string | number,
      'itemType'?: string,
    }
  },
  getCustomerInfo: {
    method: "GET",
    path: () => `org-orders-management/reports/customer-info`,
    params: {} as {
      'skip'?: string | number,
      'take'?: string | number,
      'search'?: string | number,
      'sort'?: string | number,
      'startDate'?: string | number,
      'endDate'?: string | number,
    }
  },
  getCustomerLedger: {
    method: "GET",
    path: () => `org-orders-management/reports/customer-ledger`,
    params: {} as {
      'userId': string | number,
      'skip'?: string | number,
      'take'?: string | number,
      'startDate'?: string | number,
      'endDate'?: string | number,
    }
  },
};
